import { createGlobalStyle } from 'styled-components';

import { colors, typography } from './tokens';

export default createGlobalStyle`
 * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
  }

  a {
    text-decoration: none;
  }

  html {
    scroll-behavior: smooth;
  }

  @media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }
  }

  /* Compensa a altura do header sticky ao pular pra uma âncora (ex.:
     nav "Recursos" -> #recursos), senão o topo da seção fica escondido
     atrás do header. */
  [id] {
    scroll-margin-top: 88px;
  }

  body {
    background: ${colors.background};
    color: ${colors.textPrimary};
    -webkit-font-smoothing: antialiased;
  }

  body, input, button, textarea, select {
    font-family: ${typography.fontFamily};
    font-size: 16px;
  }

  ::selection {
    background: ${colors.primary};
    color: ${colors.onPrimary};
  }

  ::placeholder {
    color: ${colors.textFaintest};
  }

  summary::-webkit-details-marker {
    display: none;
  }

  summary {
    list-style: none;
    cursor: pointer;
  }

  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 500;
  }

  button {
    cursor: pointer;
  }


  :root {
    --st-modal-boxShadow: 0 10px 50px rgba(0, 0, 0, 0.8);
    --st-modal-borderRadius: 15px;

    --st-modal-transformVisible: translate3d(-50%, -50%, 0) scale(1) rotateX(0);

    --st-dialog-maxWidth: 900px;

    @media (max-width: 1199px) {
      --st-dialog-baseWidth: 90%;
      --st-dialog-maxWidth: 90%;
    }
  }


`;
